const extensions = {
  doc: ['doc', 'docx', 'odt', 'rtf', 'tex', 'txt', 'wpd'],
  pdf: ['pdf'],
  video: [
    '3g2',
    '3gp',
    'avi',
    'flv',
    'h264',
    'm4v',
    'mkv',
    'mov',
    'mp4',
    'mpg',
    'mpeg',
    'rm',
    'swf',
    'vob',
    'wmv',
  ],
  audio: [
    'aif',
    'cda',
    'mid',
    'midi',
    'mp3',
    'mpa',
    'ogg',
    'wav',
    'wma',
    'wpl',
  ],
  xls: ['ods', 'xls', 'xlsm', 'xlsx'],
  image: [
    'jpg',
    'jpe',
    'jif',
    'jfif',
    'jfi',
    'jpeg',
    'png',
    'gif',
    'tif',
    'tiff',
    'bmp',
    'dib',
    'webp',
    'heif',
    'heic',
    'svg',
  ],
};

function getFileExtension(filePath: string) {
  const extension = getFilePathExtension(filePath).toLowerCase();

  if (extensions.doc.includes(extension)) {
    return 'doc';
  } else if (extensions.pdf.includes(extension)) {
    return 'pdf';
  } else if (extensions.video.includes(extension)) {
    return 'video';
  } else if (extensions.audio.includes(extension)) {
    return 'audio';
  } else if (extensions.xls.includes(extension)) {
    return 'xls';
  } else if (extensions.image.includes(extension)) {
    return 'jpg';
  } else {
    return 'other';
  }
}

function getFilePathExtension(fileName: string) {
  return fileName
    ? fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2)
    : '';
}

export { getFileExtension };
